export const ENDORSEMENT_FIELDS_TRANSLATIONS = {
  operationType: 'Tipo de Operação',
  profileCanOpenEndorsement: 'Perfil',
  recalculate: 'Recalcula',
  recalculationType: 'Tipo de Recálculo',
  timeCalculationMethod: 'Método de Cálculo',
  editableFields: 'Campos Editáveis',
  updatedAt: 'Última Alteração',
  createdAt: 'Data de Criação',
};
